import React from 'react';
import TabHeader from '@/components/tabs/TabHeader';
import SelectCohortDatasets from '../containers/SelectCohortDatasets';
import SelectCohortDictionaries from '../containers/SelectCohortDictionaries';

const SelectCohortSourceCompact = ({ category, code }) => (
  <>
    <TabHeader headerId="cohort.select.source" icon="chevron right" />
    <SelectCohortDatasets code={code} category={category} />
    <SelectCohortDictionaries code={code} category={category} />
  </>
);

export default SelectCohortSourceCompact;
